import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IKnowladgeGraphDifferencesDataInput, IKnowledgeGraphMergeResponse } from '../../../../../../interface/interfaces';

interface IInitialState {
    knowledgeGraphMergeLoading: boolean;
    knowledgeGraphMergeData: IKnowledgeGraphMergeResponse;
    knowledgeGraphMergeError: string;
}

const initialState: IInitialState = {
    knowledgeGraphMergeLoading: false,
    knowledgeGraphMergeData: { message: '' },
    knowledgeGraphMergeError: '',
};

const knowledgeGraphMergeSlice = createSlice({
    name: 'inFlowTransferSlice',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchKnowledgeGraphMergePeding: (state: IInitialState, action: PayloadAction<IKnowladgeGraphDifferencesDataInput>) => {
            state.knowledgeGraphMergeLoading = true;
            state.knowledgeGraphMergeError = '';
        },
        fetchKnowledgeGraphMergeFulfilled: (state: IInitialState, action: PayloadAction<IKnowledgeGraphMergeResponse>) => {
            state.knowledgeGraphMergeLoading = false;
            state.knowledgeGraphMergeData = action.payload;
            state.knowledgeGraphMergeError = '';
        },
        fetchKnowledgeGraphMergeFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.knowledgeGraphMergeLoading = false;
            (state.knowledgeGraphMergeData = { message: '' }), (state.knowledgeGraphMergeError = action.payload);
        },
    },
});

export default knowledgeGraphMergeSlice.reducer;
export const { fetchKnowledgeGraphMergePeding, fetchKnowledgeGraphMergeFulfilled, fetchKnowledgeGraphMergeFailure } = knowledgeGraphMergeSlice.actions;
